export const SEVERITY_COLOR: Record<string, string> = {
  error:   '#d32f2f',
  warning: '#ed6c02',
  success: '#2e7d32',
  info:    '#0288d1',
};

export const SEVERITY_BG: Record<string, string> = {
  error:   '#ffebee',
  warning: '#fff3e0',
  success: '#e8f5e9',
  info:    '#e3f2fd',
};
